import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  if (!state.url.startsWith('/redefinir-senha')) {
    authService.saveRedirectUrl(state.url);
  }

return router.createUrlTree(['/login']);
};